import { isNumber } from 'common/utils';
import { axios } from 'libs';

const resource = '/tipos-ausencia';

export const findAllAutocomplete = searchParam => {
  const search = isNumber(searchParam)
    ? ` id=="${searchParam}"`
    : ` descricao=="*${searchParam}*"`;

  return axios.get(resource, {
    params: {
      search: `ativo==true and ${search}`,
      sort: 'descricao'
    }
  });
};
